/**
 * Created by Mohamed on 4/28/2016.
 */
(function (app, $, TeamScheduleAPI, TeamCommunicationAPI) {

    var notificationsModal = {};

    var ScheduleController = function ($scope, $state, $stateParams, TeamCommunicationService, hUser, TSSideBarService, TSPullingService, teamScheduleService, $modal, userServices, userPermissions, hTransitions, hSocket) {
        var tsSideBar = new TSSideBarService($scope);
	    var activeTeamCommunicationTab;
        let tsPullService;
        let events = {
            'NEWS_FEED_ADDED': (data) => {
                callNeededCounts(data);
            },
        };
        $scope._teamCommunicationService = new TeamCommunicationService($scope);
        $scope.isEmployer = hUser.isEmployer();

        var unhookTransitionStart = hTransitions.onSuccess({}, function (trans) {
            var toState = trans.to();
            if (toState.name.indexOf('appLayout.schedule.tl-communication-hub') > -1) {
                $scope.inCommsHubPage = true;
            } else {
                $scope.inCommsHubPage = false;
            }
        });

        let registerEvents = () => {
            for (const eventName in events) {
                hSocket.registerEvent(eventName, events[eventName]);
            }
        };

        const init = async () => {
            tsPullService = TSPullingService.init();
            if (hUser.isEmployer()) {
                tsPullService.registerService("teamCommunication", callNeededCounts);
            } else {
                tsPullService.registerService("employeeTeamCommunication", callNeededCounts);
                const config = environmentsConfig.get('EmployeeAppPusherConfig');
                await hSocket.init(config, LiveScheduleAPI.getPusherSocketAuthToken, 'private-employee-');
                registerEvents();
            }
        };

        $scope.showSideBar = false;

        var initSideBar = function () {
            $scope.showSideBar = false;
            if (hUser.isEmployer()) {
                userServices.isServiceEnabled(userServices.SERVICES.NEWS_FEED, $scope.schedule_brand.id).then(function (isNewsFeedEnabled) {
                    $scope.showSideBar = isNewsFeedEnabled;
                });
            } else {
                $scope.showSideBar = true;
            }
        };

        $scope.toggleSidebar = function() {
            tsSideBar.toggle();
        };

        setTimeout(function () {
            if (['messages'].indexOf($stateParams['sidebar']) > -1) {
                tsSideBar.open();

                if ($stateParams['sidebar'] === 'messages') {
                    $scope._teamCommunicationService.showMessages();
                }

                $state.go('.', { sidebar: undefined });
                $scope.$apply();
            }
        }, 100);


	    const loadOfferTimeOffsAvailabilitiesCount = () => {
		    if (hUser.isEmployer()) {
                teamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        var promises = {};
                        promises['offer'] = TeamScheduleAPI.getBrandShiftOfferCount(brand.id);

                        $q.all(promises)
                            .then(function (counts) {
                                $scope.shiftOfferRequestCount = counts.offer['offer'].requestCount;
                                $scope.shiftOfferActivityCount = counts.offer['offer'].activityCount;
                                $scope.$digest();
                            })
                            .catch(function (err) {
                                console.error(err);

                                if (err?.data?.status_code === 403) {
                                    if (hUser.isEmployer()) {
                                        tsPullService.registerService("teamCommunication", null);
                                    } else {
                                        tsPullService.registerService("employeeTeamCommunication", callNeededCounts);
                                    }
                                }
                            });
                    })
		    }
		    else {
                teamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        if (brand.team_live_country_code === "US") {
                            TSAvailabilityAPI.getEmployeeNotificationsCount(brand)
                                .then(function (counts) {
                                    $scope.shiftOfferRequestCount = counts.offer.requestCount;
                                    $scope.shiftOfferActivityCount = counts.offer.activityCount;
                                    $scope.timeoffsRequestCount = counts.timeOff.requestCount;
                                    $scope.timeoffsActivityCount = counts.timeOff.activityCount;
                                    $scope.availabilityRequestCount = counts.availability.requestCount;
                                    $scope.availabilityActivityCount = counts.availability.activityCount;
                                    $scope.$digest();
                                });
                        }
                    });
		    }
	    };

	    const loadConversationsPostsCount = () => {

            TeamCommunicationAPI.getUserNotificationsCounts($scope.schedule_brand.id)
                .then(function (count) {
                    $scope.unreadPostsCount = count.post.count;
                    $scope.$digest();
                })
                .catch(function (err) {
                    console.error(err);

                    if (err?.data?.status_code === 403) {
                        if (hUser.isEmployer()) {
                            tsPullService.registerService("teamCommunication", null);
                        } else {
                            tsPullService.registerService("employeeTeamCommunication", callNeededCounts);
                        }
                    }
                });
	    };

        teamScheduleService.getActiveBrand()
            .then(function (brand) {
                $scope.schedule_brand = brand;
                initSideBar();
                init();

                if (hUser.isEmployer()) {
                    openNotificationsModal();
                }
            });

        var onBrandChangeHandler = teamScheduleService.onBrandChanged(function (oldBrand, newBrand) {
            $scope.schedule_brand = newBrand;
            initSideBar();
            if (hUser.isEmployer()) {
                openNotificationsModal();
            }
        });

	    const callNeededCounts = (data) => {
            if (data && !(data.brand_id === $scope.schedule_brand?.id || data.top_brand_id === $scope.schedule_brand?.id)) {
                return;
            }
		    loadConversationsPostsCount();
		    loadOfferTimeOffsAvailabilitiesCount();
	    };

	    var openNotificationsModal = function () {

            if ([
                'appLayout.schedule.time-off',
                'appLayout.schedule.shift-trading',
                'appLayout.schedule.availability-requests',
                'appLayout.schedule.absence-requests',
                'appLayout.schedule.logbook.dashboard',
                'appLayout.schedule.logbook.logbook-team-tasks',
                'appLayout.schedule.logbook.logbook-entries',
                'appLayout.schedule.logbook.logbook-checklists',
                'appLayout.schedule.sickness-requests'
            ].indexOf($state.current.name) > -1) {
                return;
            }

            var activeBrandId = $scope.schedule_brand.id;
            var initPromises = {
                'brandSetting': teamScheduleService.getActiveBrand(),
                'isLogbookEnabled': userServices.isServiceEnabled(userServices.SERVICES.LOGBOOK, $scope.schedule_brand.id),
                'policyParser': userPermissions.getBrandPolicy($scope.schedule_brand.id)
            };
            $q.all(initPromises)
                .then(function (res) {
                    var brand = res['brandSetting'];
                    var isLogbookEnabled = res['isLogbookEnabled'];
                    var canManageAbsenceRequests = res['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_ABSENCE_REQUESTS);
                    var canManageSicknessRequests = res['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_SICKNESS_REQUESTS);
                    var canManageTimeoffRequests = res['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_TIMEOFF_REQUESTS);
                    var canManageAnyAbsenceRequests = canManageAbsenceRequests || canManageSicknessRequests || canManageTimeoffRequests;
                    var canManageAvailabilityRequests = res['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_AVAILABILITY_REQUESTS);
                    var canManageShiftTradeRequests = res['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_SHIFT_TRADE_REQUESTS);
                    var canManageSchedule = res['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_SCHEDULE);
                    var canCreateUpdateLeaveOfAbsence = res['policyParser'].has(userPermissions.PERMISSIONS.CREATE_UPDATE_LEAVE_OF_ABSENCE);
                    var promises = {};
                    var date = moment().format('YYYY-MM-DD');
                    var previousDay = moment().subtract(1,'day').format('YYYY-MM-DD');

                    if (brand.brand_absences && brand.brand_absences.length && canManageAnyAbsenceRequests) {
                        var absencesTypes = brand['brand_absences'].map(function (item) {
                            return item.type;
                        });
                        absencesTypes = absencesTypes.filter(function (v,i) {
                            if (
                                (v === 'SICKNESS' && !canManageSicknessRequests) ||
                                (v === 'TIME_OFF' && !canManageTimeoffRequests) ||
                                (['SICKNESS', 'TIME_OFF'].indexOf(v) === -1 && !canManageAbsenceRequests)
                            ) {
                                return false;
                            }
                            return absencesTypes.indexOf(v) === i;
                        });
                        var statuses = ['PENDING_APPROVAL'];
                        if (canManageSicknessRequests) {
                            statuses.push('RETURNED_TO_WORK');
                        }
                        promises['absences'] = TSAvailabilityAPI.getBrandAbsencesCount($scope.schedule_brand.id, absencesTypes, statuses);
                    }
                    if(isLogbookEnabled) {
                        promises['logbookStats'] = LogbookAPI.getDashboardStats($scope.schedule_brand.id, {date: date});
                    }
                    if (canManageShiftTradeRequests) {
                        promises['offer'] = TeamScheduleAPI.getBrandShiftOfferCount($scope.schedule_brand.id);
                    }
                    if (canManageAvailabilityRequests) {
                        promises['availability'] = TSAvailabilityAPI.getBrandAvailabilityCount($scope.schedule_brand.id, ['PENDING_APPROVAL']);
                    }
                    if (canManageSchedule && canCreateUpdateLeaveOfAbsence) {
                        promises['leaveOfAbsence'] = TimeKeepingAlertsAPI.getAlertsStats($scope.schedule_brand.id, previousDay, 'MISSED_SHIFT_IN_LOA');
                        promises['brands'] = teamScheduleService.getBrands();
                    }

                    $q.all(promises)
                        .then(function (counts) {
                            counts.availability = counts.availability || {availability: {}};
                            counts.absences = counts.absences || {
                                sickness: {},
                                holiday: {},
                                time_off: {},
                                custom: {}
                            };
                            counts.offer = counts.offer || {offer: {}};
                            var myTasks =  (counts.logbookStats && counts.logbookStats['my_tasks']) || {};
                            for (var brandId in notificationsModal) {
                                if (parseInt(brandId) !== activeBrandId && notificationsModal[brandId]) {
                                    notificationsModal[brandId].hide && notificationsModal[brandId].hide();
                                    delete notificationsModal[brandId];
                                }
                            }

                            var leaveOfAbsenceCount = 0;

                            if (counts.leaveOfAbsence) {
                                var stats = counts.leaveOfAbsence.stats;
                                for (var index in stats.brands) {
                                    var tempBrand = stats.brands[index];
                                    var brand = _.findWhere(counts.brands, {id: tempBrand.id});
                                    if (brand) {
                                        if (tempBrand.alerts && tempBrand.alerts.length > 0) {
                                            for (var i in tempBrand.alerts) {
                                                var alert = tempBrand.alerts[i];
                                                if (alert.code == 'MISSED_SHIFT_IN_LOA') {
                                                    leaveOfAbsenceCount += alert.count;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            var showTLRequestsModal = !HStorageManager.get({
                                key: 'hide_tl_requests_modal',
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                            });

                            if (activeBrandId == $scope.schedule_brand.id && !notificationsModal[activeBrandId] && showTLRequestsModal) {
                                if (
                                    counts.absences['sickness'].requestCount ||
                                    counts.absences['holiday'].requestCount ||
                                    counts.absences['time_off'].requestCount ||
                                    counts.absences['custom'].requestCount ||
                                    counts.availability['availability'].requestCount ||
                                    myTasks.count ||
                                    counts.offer['offer'].requestCount ||
                                    leaveOfAbsenceCount
                                ) {
                                    notificationsModal[activeBrandId] = $modal({
                                        controller: 'TLNotificationsModalController',
                                        templateUrl: '../modules/team_schedule/employer/notifications/views/tl_notifications_modal.html',
                                        show: true,
                                        backdrop: "static",
                                        keyboard: false,
                                        resolve: {
                                            modalData: function () {
                                                return {
                                                    sicknessCount: counts.absences['sickness'].requestCount,
                                                    holidayCount: counts.absences['holiday'].requestCount,
                                                    timeOffCount: counts.absences['time_off'].requestCount,
                                                    customCount: counts.absences['custom'].requestCount,
                                                    availabilityCount: counts.availability['availability'].requestCount,
                                                    shiftTradeCount: counts.offer['offer'].requestCount,
                                                    myTasksCount: myTasks.count,
                                                    loaCount: leaveOfAbsenceCount
                                                };
                                            }
                                        }
                                    });
                                }
                            }
                        });
                });

        };

	    $scope._teamCommunicationService.onActiveChanged(function (activeTab) {
		    activeTeamCommunicationTab = activeTab;
		    if (activeTeamCommunicationTab == "teamWall" && tsSideBar.isOpened()) {
			    delete $scope.unreadPostsCount;
		    }

		    try {
			    $scope.$digest();
		    } catch (e) {
		    }
	    });

	    var sideBarChangeHandler = tsSideBar.onChange(function () {
		    if (tsSideBar.isOpened()) {
			    if (activeTeamCommunicationTab == "teamWall") {
				    delete $scope.unreadPostsCount;
			    }

			    try {
				    $scope.$digest();
			    } catch (e) {
			    }
		    }
	    });

	    $scope.$on("$destroy", function() {
            if (hUser.isEmployer()) {
                tsPullService.registerService("teamCommunication", null);
            } else {
                tsPullService.registerService("employeeTeamCommunication", null);
                hSocket.close();
            }
            teamScheduleService.off(onBrandChangeHandler);
		    tsSideBar.off(sideBarChangeHandler);
            unhookTransitionStart();
	    });

    };

    app.controller('ScheduleController',
        [
            '$scope',
            '$state',
            '$stateParams',
            'TeamCommunicationService',
            'hUser',
            'TSSideBarService',
            'TSPullingService',
	        'TeamScheduleService',
            '$modal',
            'userServices',
            'userPermissions',
            'hTransitions',
            'hSocket',
            ScheduleController
        ]);

})(angular.module('harriApp'), jQuery, TeamScheduleAPI, TeamCommunicationAPI);

